import { stateProps } from "../pages/admin-dashboard/admin-dashboard-blog/News/type";

const FILL_REPRESENTATIVE_INFO = "user/fill-representative-info/";

export const CHANGE_USERNAME = "user/change-username/";

export const FORGET_PASSWORD_VERIFY_OTP = "user/forget-password/verify-opt/";

export const FORGET_PASSWORD_URL = "user/forget-password/";

export const AUTH_JWTOKEN_REFRESH = "auth/jwtoken/refresh/";

export const LOAN_GUARANTOR_CHEQUES_STATES = "/loan/guarantor/cheques-states/";

export const CREDITOR_GUARANTEE_LIST = (creditor_uid: any) =>
  `/creditor/${creditor_uid}/guarantee-list/`;

export const EXEL_AT_STORE_LIST_REPORT = (
  store_state?: any
) => `excel/get-store-report/?
${store_state ? `store_state=${store_state}` : ``}
`;

export const EXEL_AT_ORDERS_CLEARED_REPORT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `excel/${creditor_uid}/order-paid/?
${until_date ? `date_until=${until_date}&` : ``}
${from_date ? `date_from=${from_date}&` : ``}
`;

export const EXEL_AT_BLU_REPORT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `excel/${creditor_uid}/blu-report/?
${until_date ? `date_until=${until_date}&` : ``}
${from_date ? `date_from=${from_date}&` : ``}
`;

export const EXEL_AT_REMAINING_DEBT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `excel/${creditor_uid}/order-paid/?
${until_date ? `date_until=${until_date}&` : ``}
${from_date ? `date_from=${from_date}&` : ``}
`;

export const DEBT_EXTRADITION_INSTALMENT = (instalment_uid: string) => {
  return `debts/extradition-instalment/${instalment_uid}/`;
};

export const DEBTS_LIST_CHEQUE_EXTRADITION = (
  creditor_uid: string | null,
  pageNumber: number,
  pageSize: number,
  state?: string | null,
  receiveType?: string | null,
  searchQuery?: any,
  sayadi_extradited?: any,
  financial_approval?: any,
  from_date?: any,
  until_date?: any
) => `/debts/list-cheque-extradition/${creditor_uid}/?page=${pageNumber}&page_size=${pageSize}
${state ? `&state=${state}` : ``}
${receiveType ? `&receive_type=${receiveType}` : ``}
${searchQuery ? `&search_query=${searchQuery}` : ``}${
  sayadi_extradited ? `&sayadi_extradited=${sayadi_extradited}` : ``
}${financial_approval ? `&financial_approval=${financial_approval}` : ``}
${from_date ? `&from_date=${from_date}` : ``}
${until_date ? `&until_date=${until_date}` : ``}`;

export const DEBTS_EXCEL_CHEQUE_EXTRADITION = (
  creditor_uid: string | null,
  state?: string | null,
  receiveType?: string | null,
  searchQuery?: any,
  sayadi_extradited?: any,
  financial_approval?: any,
  from_date?: any,
  until_date?: any
) => {
  return `/debts/excel/cheque-extradition/${creditor_uid}/?
${`state=${state?.trim()}`}
${`&sayadi_extradited=${sayadi_extradited?.trim()}`}${`&financial_approval=${financial_approval?.trim()}`}
${from_date ? `&from_date=${from_date}` : ``}
${until_date ? `&until_date=${until_date}` : ``}`;
};

export const CREDITOR_EXCEL_GUARANTEE_EXTRADITION = (
  creditor_uid: string | null,
  state?: string | null,
  receiveType?: string | null,
  searchQuery?: any,
  sayadi_extradited?: any,
  financial_approval?: any,
  from_date?: any,
  until_date?: any
) => {
  return `/creditor/excel/${creditor_uid}/guarantee-extradition/?
${`state=${state?.trim()}`}
${`&sayadi_extradited=${sayadi_extradited?.trim()}`}
${`&financial_approval=${financial_approval?.trim()}`}
${from_date ? `&from_date=${from_date}` : ``}
${until_date ? `&until_date=${until_date}` : ``}`;
};

export const EXEL_AT_STORE_CLEARED_REPORT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `excel/${creditor_uid}/store-paid/?
${until_date ? `date_until=${until_date}&` : ``}
${from_date ? `date_from=${from_date}&` : ``}
`;

export const CREDITOR_PAYMENT_REPORT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `creditor/${creditor_uid}/creditor-payment-report/?
${until_date ? `date_until=${until_date}&` : ``}
${from_date ? `date_from=${from_date}&` : ``}
`;

export const EXEL_DOCUMENT_VERIFIED_REPORT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `excel/${creditor_uid}/document-verified-report/?
${until_date ? `date_until=${until_date}&` : ``}
${from_date ? `date_from=${from_date}&` : ``}
`;

export const EXEL_AT_FINANCIAL_CHEQUES_REPORT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `excel/${creditor_uid}/at-financial-cheques-report/?
${until_date ? `date_until=${until_date}&` : ``}
${from_date ? `date_from=${from_date}&` : ``}
`;

export const EXEL_CHEQUES_REPORT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `excel/${creditor_uid}/cheques-report/?
${until_date ? `due_date_until=${until_date}&` : ``}
${from_date ? `due_date_from=${from_date}&` : ``}
`;

export const EXEL_ORDERS_REPORT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any,
  group_store?: any
) => `excel/${creditor_uid}/orders-report/?
${until_date ? `date_until=${until_date}&` : ``}
${from_date ? `date_from=${from_date}&` : ``}
${group_store ? `group_store=${group_store}&` : ``}
${group_store === null ? `` : ``}
`;

export const FORGET_CHANGE_PASSWORD = "user/forget/change-password/";

export default FILL_REPRESENTATIVE_INFO;

export const LIST_REPRESENTATIVES = "user/list-representatives/";

export const USER_IDENTITY_INFO = "user/get-identity-info/";

export const SUPERVISOR_APPROVE_ORDER = (order_uid: string | null) =>
  `supervisor/approve-order/${order_uid}`;

export const SUPERVISOR_DEFECT_ORDER = "supervisor/defect-order/";

export const SUPERVISOR_ORDER_DEFECTS = (order_uid: string | null) =>
  `supervisor/order-defects/${order_uid}`;

export const SUPERVISOR_ORDER_DEFECTS_ITEMS = "supervisor/order-defects-items/";

export const REGISTER_ORDER_SEND_OTP = "store/register-order/send-otp/";

export const STATES_CHEQUES_EXTRADITION_FILTERS =
  "/creditor/states/cheques/extradition-filters/";

export const REGISTER_ORDER_VERIFY_OTP = "store/register-order/verify-otp/";

export const INITIAL_STORE_INFO = (
  pageSize: number,
  pageNumber: number,
  state: any,
  province_id: any,
  search_query: any
) =>
  `store/initial-store-info/?page=${pageNumber}&page_size=${pageSize}${
    state ? `&state=${state}` : ``
  }${province_id ? `&province_id=${province_id}` : ``}${
    search_query ? `&search_query=${search_query}` : ``
  }`;

export const ORDER_INITIAL_APPROVAL = "store/order/initial-approval/";

export const INSTALMENT_DEBTS_LEGAL_STATEMENT =
  "instalment-debts/legal-statement/";

export const DEBTS_PAYMENT_ORDER_AMOUNT = "debts/payment/order-amount/";

export const CREDITOR_ADD_CREDITOR_USER = "/creditor/add-creditor-user/";

export const ADMIN_STAFF = "admin/staff/";

export const DEBTS_PAYMENT_ORDER_AMOUNT_LINK =
  "debts/payment/order-amount/link/";

export const SUPERVISOR_CHEQUE_DEFECTS = (order_uid: string | null) =>
  `supervisor/cheque-defects/${order_uid}`;

export const DEBTS_PENALTY_CHEQUE_DEL = (penalty_cheque_uid: string | null) =>
  `debts/penalty-cheque/${penalty_cheque_uid}/`;

export const DEBTS_DEBTS = (
  creditor_uid: string | null,
  pageNumber?: number,
  pageSize?: number,
  state?: any,
  search_query?: string,
  from_date?: any,
  until_date?: any,
  expert?: string | null,
  cheque_amount?: any,
  cheque_count?: any,
  sort_by?: any
) =>
  `debts/${creditor_uid}/debts/?page=${pageNumber}&page_size=${pageSize}${
    search_query ? `&search_query=${search_query}` : ``
  }${state ? `&state=${state}` : ``}${
    from_date ? `&from_date=${from_date}` : ``
  }${expert ? `&expert=${expert}` : ``}${
    cheque_amount ? `&cheques_amount=${cheque_amount}` : ``
  }${cheque_count ? `&cheques=${cheque_count}` : ``}${
    until_date ? `&until_date=${until_date}` : ``
  }${sort_by ? `&sort_by=${sort_by}` : ``}`;

export const LOAN_CHEQUE_REFUND = `/loan/cheque-refund/`;

export const LOAN_CHEQUE_INSTALMENT_REFUND = "/loan/cheque-instalment-refund/";

export const SUPERVISOR_INSTALMENT_DEFECTS = (instalment_uid: string | null) =>
  `supervisor/instalment-defects/${instalment_uid}/`;

export const SUPERVISOR_GUARANTEE_DEFECTS = (
  guarantee_cheque_uid: string | null
) => `supervisor/guarantee-defects/${guarantee_cheque_uid}/`;

export const APP_CONTEXT = (app_key: string | null | undefined) =>
  `core/application-context/${app_key}/`;

export const USER_HOME_CONTEXT = "user/home-context/";

export const STORE_HOME_CONTEXT = (panel_uid: string | null) =>
  `store/store-context/${panel_uid}`;

export const CREDITOR_CONTEXT = (panel_uid: string | null) =>
  `creditor/creditor-context/${panel_uid}/`;

export const GET_FILE = (file: string | null | undefined) =>
  `core/get-file/${file}/`;

export const LOAN_WAGE_PERLINK = `/loan/payment/loan-wage-link/`;

export const LOAN_WAGE_PERLINK_BLU = `/debts/payment/debt-instalment/`;

export const LOAN_TOTAL_WAGE_PERLINK = `/debts/payment/debt-order/`;

export const USER_ADDRESS_INQUIRY = (inputValue: string | null) =>
  `user/address-inquiry/${inputValue}/`;

export const LOAN_SEND_OTP_GUARANTOR = "loan/send-otp-guarantor/";

export const USER_OCR_ID_CARD = "user/ocr-id-card/";

export const POLICY_URL = "user/user_accept_policy/";

export const OTP_URL = "auth/verify-otp/";

export const GET_TOKEN = "admin/get-token/";

export const LOGIN_URL = "auth/login/";

export const USER_PASS_LOGIN = "user/login_user_pass/";

export const PASSWORD_SETTER_URL = "user/set_pass/";

export const DEBTS_PENALTY_CHEQUE = "debts/penalty-cheque/";

export const DEBTS_PAYMENT_LINK = "debts/payment-link/";

export const DEBTS_INSTALMENT_PAYMENT_LINK = "debts/instalment-payment-link/";

export const DEBTS_ORDER_PAYMENT_LINK = "debts/debt-order-link/";

export const DEBTS_PAYMENT_INITIAL_APPROVAL = "debts/payment-initial-approval/";

export const DEBTS_PAYMENT_RECEIPT_DEBTS_ORDER =
  "debts/receipt-payment/debt-order/";

export const DEBTS_PARDON_FEE = "debts/pardon-fee/";

export const CREDIT_INQUIRY_VERIFY_OTP = "loan/credit-inquiry/verify-otp/";

export const CREDIT_INQUIRY_INQUIRY = (verificationOtpTicket: string | null) =>
  `loan/credit-inquiry/inquiry/${verificationOtpTicket}/`;

export const CREDIT_INQUIRY_SEND_OTP = "loan/credit-inquiry/send-otp/";

export const STORE_PRODUCT_CREATE = "store/product-create/";

export const PRODUCT_CLASSIFY_STORE_GROUP = (store_uid: string | null) =>
  `store/product-classify/store/group/${store_uid}/`;

export const DEBTS_DETAIL_DEBT = (debt_file_uid: string | null) =>
  `debts/detail-debt/${debt_file_uid}/`;

export const PRODUCT_CLASSIFY_TYPE = (product_group_uid: string | null) =>
  `store/product-classify/type/${product_group_uid}/`;

export const PRODUCT_CLASSIFY_BRAND = (product_type_uid: string | null) =>
  `store/product-classify/brand/${product_type_uid}/`;

export const PRODUCT_CLASSIFY_PRODUCT = (
  product_type_uid: string | null,
  brand_uid: string | null
) => `store/product-classify/product/${product_type_uid}/${brand_uid}/`;

export const STORE_GET_ORDER_ITEMS = (order_uid: string | null) =>
  `store/get-order-items/${order_uid}/`;

export const STORE_ORDER_STATE_LIST = "store/order-states-list/";

export const DEBTS_PENALTY_TYPES_EXPORT_ACCESS =
  "debts/penalty-types/expert-access/";

export const STORE_ADD_ORDER_ITEM = "store/add-order-item/";

export const LOAN_GET_SELECT_LOAN = (order_uid: string | null) =>
  `loan/get-select-loan/${order_uid}/`;

export const LOAN_TERM_CONTEXT = "loan/loan-terms";

export const STORE_GET_INVOICE = (order_uid: string | null) =>
  `store/get-invoice/${order_uid}`;

export const STORE_APPROVE_INVOICE = (order_uid: string | null) =>
  `store/approve-invoice/${order_uid}/`;

export const LOAN_AVAILABLE_LOANS = (
  order_uid: string | null,
  activeButtonPeriod: number,
  activeButtonPayment: number,
  processedValue: any
) =>
  `loan/available-loans/?order_uid=${order_uid}&step=${activeButtonPeriod}&refund_period=${activeButtonPayment}&pre_payment=${processedValue}`;

export const STORE_ORDER_DETAIL = (order_uid: string | null) =>
  `store/order-detail/${order_uid}/`;

export const CREATE_COMMENT_SHOP = `/store/create-comment/`;

export const LOAN_AWAITING_TIME = (order_uid: string | null) =>
  `/loan/awaiting-time/${order_uid}/`;

export const USER_ORDER_DETAIL = (order_uid: string | null) =>
  `store/user-order-detail/${order_uid}/`;

export const ORDER_BORROW = (id: string) => `/store/order-borrow/${id}/`;

export const ADMIN_STORE_COMMENTS = (
  state: "APPROVED" | "REJECTED" | "PENDING",
  page: number
) => `admin/store-comments/?state=${state}&page=${page}`;

export const BLUE_SETTLEMENT_GET = (
  id: string,
  search?: string,
  startDate?: string,
  endDate?: string,
  pageNumber?: number,
  pageSize?: number
) =>
  `/supervisor/${id}/document-verified-order/?${
    search ? `search_query=${search}` : ""
  }${startDate ? `from_date=${startDate}&` : ""}${
    endDate ? `until_date=${endDate}&` : ""
  }${pageNumber ? `page=${pageNumber}&` : ""}${
    pageSize ? `page_size=${pageSize}&` : ""
  }`;

export const DASHBOARD_SHOPS = (store_ui: string) =>
  `/store/store-dashboard/${store_ui}/`;

export const BLUE_SETTLEMENT_SEND = (id: string) =>
  `/supervisor/${id}/send-for-settlement/`;

export const ADMIN_APPROVED_COMMENT = (id: string) =>
  `admin/approve-comment/${id}/`;
export const ADMIN_REJECTED_COMMENT = (id: string) =>
  `admin/reject-comment/${id}/`;

export const ADMIN_GET_CATEGORY_BLOG = `/portal/admin/blog-category/`;

export const ADMIN_GET_BLOG = (state: stateProps) =>
  `/portal/admin/blog/?status=${state}`;

export const ADMIN_ADD_BLOG = `/portal/admin/blog/`;
export const ADMIN_GET_BLOG_DETAIL = (id: string) => `/portal/admin/blog/${id}`;

export const ADMIN_ACTION_BLOG = (id: string) => `/portal/admin/blog/${id}/`;

export const ADMIN_ACTION_CATEGORY_BLOG = (id: string) =>
  `/portal/admin/blog-category/${id}/`;

export const LOAN_DEFECT_DETAILS = (id: string) =>
  `/loan/defect-details/${id}/`;

export const GET_ORDER_VIEW_FILE = (id: string) =>
  `/store/get-order-files/${id}/`;

export const GET_INVOICE_VIEW_FILE = (id: string) =>
  `/store/get-invoice-file/${id}/`;

export const GET_CONTRACT_VIEW_FILE = (id: string) =>
  `/core/contract-download/${id}/`;

export const LOAN_CHEQUE_DETAILS = (order_uid: string | null) =>
  `loan/cheque-details/${order_uid}`;

export const LOAN_GUARANTEE_DETAILS = (order_uid: string | null) =>
  `loan/guarantee-details/${order_uid}/`;

export const LOAN_SEND_SUPERVISOR = (order_uid: string | null) =>
  `loan/send-supervisor/${order_uid}/`;

export const STORE_UPLOAD_INVOICE = "store/upload-invoice/";

export const STORE_UPDATE_INVOICE = (order_uid: string | null) =>
  `store/update-invoice/${order_uid}/`;

export const STORE_GET_INVOICE_FILE = (order_uid: string | null) =>
  `store/get-invoice-file/${order_uid}/`;

export const STORE_STORE_BANK_INFO_CREATE = "store/store_bank_info/create/";

export const STORE_STORE_BANK_INFO_UPDATE = (store_uid: string | null) =>
  `store/store_bank_info/update/${store_uid}/`;

export const STORE_STORE_BANK_INFO_GET = (store_uid: string | null) =>
  `store/store_bank_info/get/${store_uid}/`;

export const STORE_PROMISSORY_NOTE_GET = (store_uid: string | null) =>
  `store/promissory-note/get/${store_uid}`;

export const USER_GET_IDENTITY_INFO = "user/get-identity-info/";

export const LOAN_GET_CREDIT = "loan/get-credit/";

export const USER_FILL_IDENTITY_INFO = "user/fill-identity-info/";

export const USER_IDENTITY_INFO_UPDATE = "user/identity_info/update/";

export const CORE_PROVINCE = "core/province/";
export const GET_DAYS_OF_WEEK = "/admin/order-registration-week-days/";
export const GET_DAYS_OF_WEEK_UPDATE = (uid?: string) =>
  `/admin/order-registration-week-day/${uid}/`;

export const ADMIN_EXCEPTION_DAYS_DELETE = (order_registration_uid: string) =>
  `/admin/exception-days/${order_registration_uid}/`;

export const ADMIN_EXCEPTION_DAYS = "/admin/exception-days/";

export const CORE_CITY = (id?: any) =>
  `core/city/${id !== undefined && id !== "undefined" ? `?search=${id}` : ``}`;

export const STORE_GROUPS = "store/store-group/";

export const COMMON_STORE_GROUPS = "store/common-store-groups/";

export const CORE_CITY_NO_ID = `core/city/`;

export const LOAN_EXTRADITION_CONTEXT = "/loan/extradition/context/";

export const USER_PAY_DEBTS_AMOUNTS = (instalment_uid: string | null) =>
  `/debts/debts-amounts/${instalment_uid}/`;

export const STORE_STORE_INFO_CREATE = "store/store_info/create/";

export const STORE_STORE_INFO_UPDATE = (store_uid: string | null) =>
  `store/store_info_/update/${store_uid}/`;

export const STORE_STORE_GET_INFO = "store/store_get_info/";

export const STORE_GET_STORE_LICENSE = "store/get_store_license/";

export const STORE_JOB_CATEGORY_LIST = "store/job_category_list/";

export const STORE_STORE_LICENSE_CREATE = "store/store_license/create/";

export const STORE_STORE_LICENSE_UPDATE = (store_uid: string | null) =>
  `store/store_license/update/${store_uid}/`;

export const STORE_PRODUCT_GROUP = "/store/product-group/";

export const STORE_ACCEPT_CONTRACT = "store/accept-contract/";

export const LOAN_SELECT_LOAN = "loan/select-loan/";

export const CORE_GET_COMMON_FILE = (file: string | null | undefined) =>
  `core/get-common-file/${file}/`;

export const STORE_SELECT_STORE = "store/select-store/";

export const LOAN_UPLOAD_CHEQUE_IMAGE_UID = (instalment_uid: string | null) =>
  `loan/upload-cheque-image/${instalment_uid}/`;

export const LOAN_UPLOAD_CHEQUE_IMAGE = "loan/upload-cheque-image/";

export const LOAN_UPDATE_GUARANTEE_CHEQUE = (cheque_uid: string | null) =>
  `loan/update-guarantee-cheque/${cheque_uid}/`;

export const UPLOAD_GUARANTEE_CHEQUE = "loan/upload-guarantee-cheque/";

export const LOAN_VERIFY_OTP_GUARANTOR = "loan/verify-otp-guarantor/";

export const LOAN_GUARANTOR_CONFIRM = (cheque_uid: string | null) =>
  `loan/guarantor/confirm/${cheque_uid}/`;

export const LOAN_GUARANTOR_IDENTITY_UID = (guarantor_uid: string | null) =>
  `loan/guarantor/identity/${guarantor_uid}/`;

export const LOAN_GUARANTOR_IDENTITY = "loan/guarantor/identity/";

export const DEBTS_RETURNED_CHEQUE_PAYMENT = "debts/returned-cheque-payment/";

export const LOAN_GUARANTEE_CHEQUE = (guarantee_cheque_uid: string) =>
  `/loan/guarantee-cheque/${guarantee_cheque_uid}/`;

export const LOAN_INSTALMENT = (instalment_uid: string) =>
  `/loan/instalment/${instalment_uid}/`;

export const LIST_STORE_ORDERS = (
  store_uid: string | null,
  pageNumber: number,
  pageSize: number,
  state: any,
  sort_by: string,
  search_query: string
) =>
  `store/${store_uid}/store-orders/?page=${pageNumber}&page_size=${pageSize}${
    sort_by ? `&sort_by=${sort_by}` : ``
  }${state ? `&state=${state}` : ``}${
    search_query ? `&search_query=${search_query}` : ``
  }`;

export const SUPERVISOR_STORE_INFO = (store_uid: string | null) =>
  `supervisor/store-info/${store_uid}/`;

export const SUPERVISOR_ORDER_USER_INFO = (order_uid: string | null) =>
  `supervisor/order-user-info/${order_uid}/`;

export const SUPERVISOR_STORES_LIST = (
  page: any,
  pageSize: any,
  state: any,
  city: any,
  store_group: any,
  sort_by: string,
  search_query: string,
  expert: string
) =>
  `supervisor/stores/?page=${page}&sort_by=${sort_by}&page_size=${pageSize}${
    state ? `&state=${state}` : ``
  }${city ? `&city=${city}` : ``}${
    store_group ? `&store_group=${store_group}` : ""
  }${search_query ? `&search_query=${search_query}` : ``} ${
    expert ? `&expert=${expert}` : ``
  }`;
export const SUPERVISOR_STORES_QUERY = (query: string) =>
  `supervisor/stores/?search_query=${query}`;

export const SUPERVISOR_MID_STORE_GROUP = (id?: string) =>
  `supervisor/mid-store-group/${id ? `${id}/` : ""}`;

export const SUPERVISOR_LOANS = `supervisor/loans/`;

export const SUPERVISOR_STORE_DEBTS = (creditor_uid: any) =>
  `supervisor/store-debts/${creditor_uid}/`;

export const STORE_SUPERVISOR_STORE_PAYMENT = "store/supervisor/store-payment/";

export const SUPERVISOR_EXCEL_STORES_DABT = (creditor_uid: string | null) =>
  `supervisor/excel/stores-debt/${creditor_uid}/`;

export const SUPERVISOR_ORDER_DETAILS = (order_uid: string | null) =>
  `supervisor/order-details/${order_uid}/`;

export const FINAL_APPROVAL_REVIEW = (order_uid: string | null) =>
  `supervisor/final-approval/${order_uid}/`;

export const CREDITORS_LIST = "creditor/creditors/";

export const LOAN_WAGE = "loan/payment/loan-wage/";

export const PRODUCT_DELIVERED = (order_uid: string | null) =>
  `store/product-delivered/${order_uid}/`;

export const SUPERVISOR_ORDER_LIST = (
  pageNumber: number,
  pageSize: number,
  state?: any,
  sort_by?: string,
  search_query?: string,
  from_date?: any,
  until_date?: any,
  store_group?: any,
  creditor_uid?: any
) => `supervisor/order-list/?page=${pageNumber}&page_size=${pageSize}&sort_by=${sort_by}&search_query=${search_query}${
  state ? `&state=${state}` : ``
}${until_date ? `&until_date=${until_date}` : ``}
${from_date ? `&from_date=${from_date}` : ``}${
  store_group ? `&store_group=${store_group}` : ``
}${creditor_uid ? `&creditor_uid=${creditor_uid}` : ``}`;

export const CREDITOR_GUARANTEE_RECEIVER = (
  creditor_uid: string | null,
  pageNumber: number,
  pageSize: number,
  state?: string | null,
  receiveType?: string | null,
  searchQuery?: any,
  sayadi_extradited?: any,
  financial_approval?: any,
  from_date?: any,
  until_date?: any,
  sort3value?: any
) => `/creditor/${creditor_uid}/guarantee-receiver/?page=${pageNumber}&page_size=${pageSize}
${state ? `&state=${state}` : ``}
${receiveType ? `&receive_type=${receiveType}` : ``}
${searchQuery ? `&search_query=${searchQuery}` : ``}${
  sayadi_extradited ? `&sayadi_extradited=${sayadi_extradited}` : ``
}${financial_approval ? `&financial_approval=${financial_approval}` : ``}
${from_date ? `&from_date=${from_date}` : ``}
${until_date ? `&until_date=${until_date}` : ``}${
  sort3value ? `&sort_by=${sort3value}` : ``
}`;

export const CREDITOR_ORDER_LIST = (
  creditor_uid: string | null,
  pageNumber: number | null,
  pageSize?: number | null,
  state?: any,
  apiSearch?: any,
  store_group?: any
) =>
  `supervisor/${creditor_uid}/order-list/?page=${pageNumber}&page_size=${pageSize}&search_query=${apiSearch}${
    state ? `&state=${state}` : ``
  }${store_group ? `&store_group=${store_group}` : ""}`;

export const STORE_CREDITOR_ORDER_STATES = "/store/creditor-order-states/";

export const CREDITOR_CHEQUE_STATES_LIST = "/creditor/cheque-states-list/";
export const STORE_LIST_NOTIFICATIONS = (
  store_uid: string | null,
  page?: number,
  pageSize?: number,
  is_read?: "True" | "False" | ""
) =>
  `/store/${store_uid}/notifications/?page=${page}&page_size=${pageSize}&is_read=${is_read}`;

export const USER_LIST_NOTIFICATIONS = (
  user_id: string | null,
  page?: number,
  pageSize?: number,
  is_read?: "True" | "False" | ""
) =>
  `/user/notification/?page=${page}&page_size=${pageSize}${
    is_read ? `&is_read=${is_read}` : ""
  }`;

export const STORE_SEEN_NOTIFICATION = (notification_uid: string | null) =>
  `/store/seen-notification/${notification_uid}/`;

export const USER_SEEN_NOTIFICATION = (notification_uid: string | null) =>
  `/user/seen-notification/${notification_uid}/`;

export const USER_NOTIFICATION = "user/notification/";

export const STORE_STORE_LICENSE = (store_uid: string | null) =>
  `store/store-license/${store_uid}/`;

export const STORE_STORE_GET_INFO_UID = (store_uid: string | null) =>
  `store/store-info/${store_uid}/`;

export const STORE_STORES_UID = (store_uid: string | null) =>
  `store/stores/${store_uid}/`;

export const STORE_USER_ORDERS = "store/user-orders/";
export const USER_INSTALMENTS = "loan/user-instalments/";
export const USER_GUARANTEES = "loan/guarantees/";

export const STORE_ORDERS_USER = "store/orders-user/";
export const USER_ACTIVE_ORDER = "store/active-order/";

export const USER_RESIDENTIAL_INFO_UPDATE = "user/residential_info/update/";

export const USER_FILL_RESIDENTIAL_INFO = "user/fill-residential-info/";

export const USER_GET_RESIDENTIAL_INFO = "user/get-residential-info/";

export const USER_UPDATE_JOB_INFO = "user/update-job-info/";

export const USER_GET_JOB_INFO = "user/get-job-info/";

export const USER_FILL_JOB_INFO = "user/fill-job-info/";

export const USER_UPDATE_REPRESENTATIVE_INFO = (representative_uid: string) =>
  `user/update-representative-info/${representative_uid}/`;

export const LOAN_GUARANTOR_RESIDENTIAL_NO_UID = "loan/guarantor/residential/";

export const LOAN_GUARANTOR_RESIDENTIAL_WITH_UID = (guarantor_uid: string) =>
  `loan/guarantor/residential/${guarantor_uid}/`;

export const AUTH_JWTOKEN_VERIFY = "auth/jwtoken/verify/";

export const STORE_UPLOAD_IMAGE = (store_uid: string | null) =>
  `store/upload-image/${store_uid}/`;

export const PARDON_FEE = (creditor_uid: string | null) =>
  `debts/pardon-fee/${creditor_uid}/`;

export const UNDO_PARDON_FEE = (pardon_fee_uid: string | null) =>
  `debts/undo-pardon-fee/${pardon_fee_uid}/`;

// debts/undo-pardon-fee/df64fd61-314d-4a67-82b4-51d6da7eb0d6/
export const STORE_UPLOAD_LOGO = (store_uid: string | null) =>
  `store/upload-logo/${store_uid}/`;

export const BANKS = "core/banks/";

export const BANKS_LIST = "core/banks-list/";

export const SUPERVISOR_CREDITOR_ORDER_LIST = (
  creditor_uid: string | null,
  pageNumber: number,
  pageSize: number,
  state?:
    | "PRODUCT_DELIVERED"
    | "DOCUMENT_UPLOADED"
    | "FILE_SENT"
    | "FILE_RECEIVED"
    | "PHYSICAL_DOCUMENT_DEFECT"
    | "DOCUMENTS_VERIFIED"
    | "ORDER_PAID"
    | "COMPLETED"
    | "",
  search_query?: string,
  until_date?: any,
  from_date?: any
) => {
  let url = `supervisor/${creditor_uid}/orders/?page=${pageNumber}${
    state ? `&state=${state}` : ``
  }&search_query=${search_query}&page_size=${pageSize}`;

  if (from_date) {
    url += `&from_date=${from_date}`;
  }
  if (until_date) {
    url += `&until_date=${until_date}`;
  }
  url = url.endsWith("&") ? url.slice(0, -1) : url;
  return url;
};

export const SUPERVISOR_CHEQUES_AMOUNT = (order_uid: string | null) =>
  `supervisor/order-factors/${order_uid}/`;

export const SUPERVISOR_MANUAL_CREDIT = (store_credit_uid: string) =>
  `store/supervisor/manual-credit/${store_credit_uid}/`;

export const SUPERVISOR_STORE_CREDIT = (
  page?: string | number,
  page_size?: string | number,
  search_query?: string,
  manual_rate?: string,
  manual_credit?: string,
  exception?: string,
  creditor?: string
) =>
  `store/supervisor/store_credit/?manual_rate=${
    manual_rate ? manual_rate : ""
  }&manual_credit=${manual_credit ? manual_credit : ""}&exception=${
    exception ? exception : ""
  }&search_query=${
    search_query ? search_query : ""
  }&page=${page}&page_size=${page_size}`;

export const SUPERVISOR_RECEIVE_FILE = () => `supervisor/receive-file/`;

export const SUPERVISOR_ORDER_USER_LIST = (
  pageNumber: number,
  pageSize: number,
  state?: any,
  apiSearch?: any
) =>
  `admin/users/?page=${pageNumber}&page_size=${pageSize}&search_query=${apiSearch}${
    state ? `&state=${state}` : ``
  }`;

export interface ChequeListOptions {
  state?: string | null;
  search_query?: string | null;
  from_date?: string | null;
  until_date?: string | null;
  sort_by?: string | null;
}
export const SUPERVISOR_CREDITOR_UID_GET_CHEQUE_LIST = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any,
  state?: any,
  search_query?: any,
  sort_by?: any
) => {
  let url = `supervisor/${creditor_uid}/cheques/?page=1&page_size=200&`;
  if (state) {
    url += `state=${state}&`;
  }
  if (search_query) {
    url += `search_query=${search_query}&`;
  }
  if (from_date) {
    url += `from_date=${from_date}&`;
  }
  if (until_date) {
    url += `until_date=${until_date}&`;
  }
  if (sort_by) {
    url += `sort_by=${sort_by}`;
  }
  url = url.endsWith("&") ? url.slice(0, -1) : url;
  return url;
};
export const SUPERVISOR_APPROVAL_REVIEW = "supervisor/approval-review/";

export const SUPERVISOR_IN_BANK_CHEQUES = (
  page?: any,
  pageSize?: any,
  creditor_uid?: any,
  from_date?: any,
  until_date?: any,
  search_query?: any,
  sort_by?: any
) => {
  let url = `supervisor/${creditor_uid}/in-bank-cheques/?`;
  if (page) {
    url += `page=${page}&`;
  }
  if (pageSize) {
    url += `page_size=${pageSize}&`;
  }

  if (search_query) {
    url += `search_query=${search_query}&`;
  }

  if (from_date) {
    url += `from_date=${from_date}&`;
  }
  if (until_date) {
    url += `until_date=${until_date}&`;
  }
  if (sort_by) {
    url += `sort_by=${sort_by}`;
  }

  url = url.endsWith("&") ? url.slice(0, -1) : url;

  return url;
};

export const DEBTS_EXCEL_CHEQUES_CREDITOR_UID = (
  creditor_uid: string | null
) => {
  return `debts/excel-cheques/${creditor_uid}/`;
};

export const DEBTS_GUARANTEE_EXCEL_CHEQUES_CREDITOR_UID = (
  creditor_uid: string | null
) => {
  return `debts/guarantee-excel/${creditor_uid}/`;
};

export const DEBTS_EXCEL_LEGAL_CLAIM_CHEQUES_CREDITOR_UID = (
  creditor_uid: string | null,
  mode: "legal" | "claim"
) => {
  return `excel/cheques/${creditor_uid}/excel-ready-for-${mode}-statement/`;
};

export const SUPERVISOR_CHEQUES_SEND_BANK = `supervisor/cheques-send-bank/`;
export const GET_BANK_LIST = () => {
  return `core/banks/`;
};
export const SUPERVISOR_GET_IDENTITY_INFO = (user_uid: string | null) => {
  return `supervisor/identity-info/${user_uid}`;
};

export const ORDER_DEFECT_ITEMS = (order_uid: string | null) => {
  return `loan/defect-details/${order_uid}/`;
};

export const USER_PROFILE = `user/profile/`;

export const USER_RESIDENTIAL_INFO = `user/get-residential-info/`;
export const USER_JOB_INFO = `user/get-job-info/`;
export const USER_REPRESENTATIVE_LIST = `user/list-representatives/`;

export const SUPERVISOR_RECIEVE_FILE = "supervisor/receive-file/";

export const DEBTS_CHEQUE_STATE = "debts/cheque-state/";

export const DEBTS_CHEQUE_EXCELL = (id: string) =>
  `excel/${id}/excel-instalment/`;

export const SUPERVISOR_IN_BANK_CHEQUE = (creditor_uid: string) => {
  return `supervisor/${creditor_uid}/in-bank-cheques/`;
};
export const SUPERVISOR_RESIDENTIAL_INFO = (user_uid: string | null) => {
  return `supervisor/residential-info/${user_uid}`;
};

export const SUPERVISOR_JOB_INFO = (user_uid: string | null) => {
  return `supervisor/job-info/${user_uid}`;
};

export const SUPERVISOR_REPRESENTATIVES_INFO = (user_uid: string | null) => {
  return `supervisor/representatives-info/${user_uid}`;
};

export const SUPERVISOR_USER_ORDERS = (user_uid: string | null) => {
  return `supervisor/user-orders/${user_uid}`;
};

export const CREDITOR_SET_CHEQUE_STATE = "creditor/set-cheque-state/";

export const DEBTS_CHEQUE_DEBT_CHEQUE_UID_CHEQUE_NOTES = (
  cheque__debt_cheque_uid: string | null
) => {
  return `debts/${cheque__debt_cheque_uid}/cheque-notes/`;
};
export const DEBTS_CHEQUE_NOTE = "debts/cheque-note/";

export const GUARANTEE_DEBTS_CHEQUE_NOTE = "debts/guarantee-cheque-note/";

export const DEBTS_LIST_DETAILS_CHEQUE = (debt_file_uid: string | null) => {
  return `debts/list-details-cheque/${debt_file_uid}/`;
};

export const DEBTS_DEBT_REPORT_PDF = (debt_file_uid: string) =>
  `debts/debt-report-pdf/${debt_file_uid}/`;

export const DEBTS_DEBT_ALL_REPORT_PDF = (debt_file_uid: string) =>
  `debts/debts-reports-pdf/${debt_file_uid}/`;

export const DELETE_CHEQUE_NOTE = (note_uid: string | null) => {
  return `debts/cheque-note/${note_uid}/`;
};
export const UPDATE_CHEQUE_NOTE = (note_uid: string | null) => {
  return `debts/cheque-note/${note_uid}/`;
};

export const GUARANTEE_UPDATE_CHEQUE_NOTE = (note_uid: string | null) => {
  return `debts/guarantee-cheque-note/${note_uid}/ `;
};

export const SUPERVISOR_STORE_REJECT = (store_uid: string | null) => {
  return `store/supervisor/store-reject/${store_uid}/`;
};

export const SUPERVISOR_STORE_VERIFY = (store_uid: string | null) => {
  return `store/supervisor/store-verify/${store_uid}/`;
};

export const DEBTS_CONFIRM_CHEQUE_PASSED = (debt_cheque_uid: string | null) => {
  return `debts/confirm-cheque-passed/${debt_cheque_uid}/`;
};

export const DEBTS_FILE_RETURNED_CHEQUE = (file_uid: string | null) => {
  return `debts/file-returned-cheque/${file_uid}/`;
};

export const SEND_LEGAL = (debt_file_uid: string | null) => {
  return `debts/send-legal/${debt_file_uid}/`;
};

export const DEBTS_RETURNED_CHEQUE = "debts/returned-cheque-doc/";

export const CREATE_LEGAL_STATEMENT = () => {
  return `debts/legal-statement/`;
};

export const CREATE_CLAIM_STATEMENT = () => {
  return `debts/claim-statement/`;
};

export const DEBTS_SEND_TO_BANK_STATE = (debt_cheque_uid: string | null) => {
  return `debts/debt-financial-state/${debt_cheque_uid}/`;
};

export const PHYSICAL_APPROVAL = "supervisor/physical-approval/";

export const PHYSICAL_FINAL_APPROVAL = (order_uid: string | null) =>
  `supervisor/physical-final-approval/${order_uid}/`;

export const CORE_COMMON_QUESTION_LIST = "core/common-question/list/";

export const DEBTS_RETURNED_BANK_CHEQUES = (
  creditor_uid: string | null,
  pageNumber?: any | null,
  pageSize?: any | null,
  search_query?: any | null
) =>
  `debts/${creditor_uid}/returned-bank-cheques/?search_query=${search_query}&page=${pageNumber}&page_size=${pageSize}`;

export const EXPORT_EXCEL_REPORTS = (
  pageNumber?: any | null,
  pageSize?: any | null
) => `core/export-excel-reports/?&page=${pageNumber}&page_size=${pageSize}`;

export const DEBTS_DEBT_FINANCIAL_GUARANTEE = (
  creditor_uid: string | null,
  pageNumber?: any | null,
  pageSize?: any | null,
  search_query?: any | null
) =>
  `debts/${creditor_uid}/debt-financial/guarantees/?search_query=${search_query}&page=${pageNumber}&page_size=${pageSize}`;

export const DEBTS_RETUNRNED_CHEQUE_TAG_NUMBER = (
  debt_cheque_uid: string | null
) => {
  return `debts/retunrned-cheque-tag-number/${debt_cheque_uid}/`;
};

export const DEBTS_DEBT_GUARANTEE_CHEQUE = (debt_cheque_uid: string | null) => {
  return `debts/debt-gurantee-cheque/${debt_cheque_uid}/`;
};

export const CREDITOR_TAKEN_BACK = (guarantee_cheque_uid: string | null) => {
  return `creditor/taken-back/${guarantee_cheque_uid}/`;
};

export const SUPERVISOR_PHYSICAL_REVIEW = (order_uid: string | null) =>
  `physical-review/${order_uid}/`;

export const SUPERVISOR_APPROVAL_CHEQUE = (instalment_uid: string) =>
  `supervisor/approve-cheque/${instalment_uid}`;

export const SUPERVISOR_APPROVAL_GUARANTEE_CHEQUE = (
  guarantee_cheque_uid: string
) => `supervisor/approve-guarantee-cheque/${guarantee_cheque_uid}`;

export const SUPERVISOR_PHYSICAL_REVIEW_DEFECT = "supervisor/physical-review/";

export const PHYSICAL_GET_ORDER_REVIEW = (order_uid: string) =>
  `supervisor/physical-review/${order_uid}/`;

export const SUPERVISOR_REVIEW_ORDER = (order_uid: string | null) =>
  `supervisor/review-order/${order_uid}/`;

export const GET_POLICY = "user/user_get_policy/";

export const SUPERVISOR_REMOVE_CHEQUE_BACK_IMAGE = (
  instalment_uid: string | null
) => `supervisor/remove-cheque-back-image/${instalment_uid}/`;

export const DEBTS_DETAILS_GUARANTEE = (debt_file_uid: string | null) =>
  `debts/details-guarantee/${debt_file_uid}/`;

export const USER_USER_GET_POLICY = `user/user_get_policy/`;

export const DEBTS_PAYMENT_RECEIPT = (receipt_file_uid: string | null) =>
  `debts/payment-receipt/${receipt_file_uid}/`;

export const DEBT_EXPERT_LIST = (creditor_uid: string | null) =>
  `/debts/debt-expert-list/${creditor_uid}/`;

export const CORE_CONTRACT_DOWNLOAD = (order_uid: string | null) =>
  `core/contract-download/${order_uid}/`;

export const STORE_ORDER_CONTRACT = `store/order-contract/`;

export const STORE_ORDER_DOWNLOAD = (order_uid: string | null) =>
  `store/order-download/${order_uid}/`;

export const STORE_PRODUCT_DELIVERY_NOTE = `store/product-delivery-note/`;

export const STORE_UPLOAD_CONTRACTS = `store/upload-contracts/`;

export const STORE_DOCUMENT_DELIVERY = (order_uid: string | null) =>
  `store/document-delivery/${order_uid}`;

export const STORE_GET_ORDER_FILES = (order__order_uid: string | null) =>
  `store/get-order-files/${order__order_uid}/`;

export const STORE_COSTUMER_ARREARS = (store_uid: string | null) =>
  `store/${store_uid}/costumer-arrears/`;

export const STORE_INVOICE_DOWNLOAD = (order_uid: string | null) =>
  `store/invoice-download/${order_uid}/`;
export const CANCEL_ORDER = `/store/cancel-order/`;

export const STORE_CHECK_POLICY = `/store/check-policy/`;

export const STORE_ACCEPT_POLICY = `/store/store_accept_policy/`;

export const STORE_DEACTIVE = (store_uid: string | null) =>
  `/store/store-deactive/${store_uid}/`;

export const STORE_SUSPEND = (store_uid: string | null) =>
  `/store/store-suspend/${store_uid}/`;

export const SUPERVISOR_STORE_NOTE = `/supervisor/store-note/`;

export const STORE_GET_POLICY = `/store/store_get_policy/`;

export const SUPERVISOR_STORE_NOTES_LIST = (store_uid: string | null) =>
  `/supervisor/store-notes-list/${store_uid}/`;

export const supervisor_store_note_Delete = (store_note_uid: string | null) =>
  `/supervisor/store-note/${store_note_uid}/`;

export const SUPERVISOR_STORE_NOTE_EDIT = (store_note_uid: string | null) =>
  `/supervisor/store-note/${store_note_uid}/`;

export const ADMIN_COMMON_QUESTION = `/admin/common-question/`;

export const PORTAL_ADMIN_MESSAGE_PATTERN = (
  pageNumber: any,
  pageSize: any,
  active: any,
  title: any,
  relate: any
) =>
  `portal/admin/message-pattern/?page=${pageNumber}&page_size=${pageSize}&active=${active}&search_query=${title}&relate=${relate}`;

export const INSTALMENT_MESSAGE_BLU = `/admin/instalment-message/?creditor=11b6d3e6-6836-4a3a-a985-db2a3dd5473c`;

export const PORTAL_ADMIN_MESSAGE_PATTERN_UPDATE = (id: string) =>
  `/portal/admin/message-pattern/${id}/`;

export const STORE_INFO_UID = (store_uid: string | null) =>
  `store/store-get-info/${store_uid}`;

export const STORE_INFO_UPDATE = (store_uid: string | null) =>
  `/store/store_info_/update/${store_uid}/`;

export const ADMIN_COMMON_QUESTION_DELETE = (
  common_question_uid: string | null
) => `/admin/common-question/delete/${common_question_uid}/`;

export const ADMIN_COMMON_QUESTION_UPDATE = (
  common_question_uid: string | null
) => `/admin/common-question/update/${common_question_uid}/`;

export const ADMIN_GET_CREDITORS = `/admin/creditor/`;

export const ADMIN_UPDATE_CREDITORS = (creditor_uid: string) =>
  `/admin/creditor/${creditor_uid}/`;

export const ADMIN_CREATE_CREDITORS_LOAN = `/loan/loan/`;
export const ADMIN_CREDITOR_CONDITION = (uid: string) =>
  `/loan/creditor-condition/${uid}/`;

export const ADMIN_CREDITOR_CONDITION_ADD = `/loan/creditor-condition/`;

export const ADMIN_CREDITOR_DOCUMENT = (uid: string) =>
  `/loan/creditor-document/${uid}/`;

export const ADMIN_CREDITOR_GUARANTEE_ADD = "/loan/guarantee-term/";

export const ADMIN_CREDITOR_GUARANTEE = (uid: string) =>
  `/loan/guarantee-terms/${uid}/`;

export const ADMIN_CREDITOR_GUARANTEE_ACTION = (uid: string) =>
  `/loan/guarantee-term/${uid}/`;

export const ADMIN_CREDITOR_TERM = (creditor_uid: string) =>
  `/loan/loan-terms/${creditor_uid}/`;
export const ADMIN_STOCK_SHARING = (uid: string) =>
  `/loan/stock-sharing-term/${uid}/`;

export const ADMIN_STOCK_SHARING_ADD = "/loan/stock-sharing-term/";

export const LOAN_GATEWAYS = "/loan/gateways/";

export const ADMIN_CREDITOR_TERM_ACTION = (uid: string) =>
  `/loan/loan-term/${uid}/`;

export const ADMIN_CREDITOR_TERM_ADD = `/loan/loan-term/`;

export const ADMIN_CREDITOR_DOCUMENT_ADD = `/loan/creditor-document/`;

export const GET_STORE_RATING = `/store/store-ratings/`;

export const ADMIN_UPDATE_CREDITORS_LOAN = (loan_uid: string) =>
  `/loan/loan/${loan_uid}/`;

export const ADMIN_GET_CREDITORS_LOAN = (creditor_uid: string) =>
  `/creditor/${creditor_uid}/creditor-loans/`;

export const STORE_STORES = `store/stores/`;

export const STORE_CANCEL_ORDER = (order_uid: string | null) =>
  `/store/seller-cancels-order/${order_uid}/`;

export const ORDER_LIST_STATE = "/store/order-list-state/";

export const ORDER_GROUP_STATE = "/store/order-group-state/";

export const GET_PIE_CHART_STORE = (creditor: string | null) =>
  `/store/chart/order-state/${creditor ? `?creditor=${creditor}` : ``}`;

export const GET_PIE_CHART_STORE_STATE = `/store/chart/store-state/`;

export const GET_CHART_ORDER_PAID = (creditor_uid: string | null) =>
  `/store/chart/order-paid/${
    creditor_uid ? `?creditor_uid=${creditor_uid}` : ``
  }`;

export const USER_STEP = "/user/step/";

export const CREDITOR_EXPERT_LIST = (creditor_uid: string | null) =>
  `/debts/creditor-expert-list/${creditor_uid}/`;

export const USER_STAFFS = "/user/staffs/";

export const ASSIGN_EXPERT = "/debts/assign-expert/";

export const STORE_ASSIGN_STORES_STAFF = "/store/assign-stores-staff/";

export const STORE_SELLER_CANCELS_ORDER = (order_uid: string | null) =>
  `/store/seller-cancels-order/${order_uid}/`;

export const FINANCIAL_DEBTS = (creditor_uid: string | null) =>
  `/debts/financial-paymetns/${creditor_uid}/`;

export const DEBT_FINANCIAL = (
  creditor_uid: string | null,
  sent_place?: any,
  state_query?: any,
  search_query?: any,
  page?: any,
  page_size?: any
) => {
  let url = `/debts/${creditor_uid}/debt-financial/`;
  if (search_query) {
    url += `?search_query=${search_query}&`;
  }
  if (sent_place) {
    url += `?sent_place=${sent_place}&`;
  }
  if (page) {
    url += `?page=${page}&`;
  }
  if (page_size) {
    url += `?page_size=${page_size}&`;
  }
  if (state_query) {
    url += `state_query=${state_query}&`;
  }
  url = url.endsWith("&") ? url.slice(0, -1) : url;
  return url;
};

export const RETURN_BANK_CHEQUES = (
  creditor_uid: string | null,
  page?: any,
  page_size?: any,
  search_query?: any,
  from_date?: any,
  until_date?: any,
  sort_by?: any
) => {
  let url = `/supervisor/${creditor_uid}/return-to-bank-cheques/`;

  if (search_query) {
    url += `?search_query=${search_query}&`;
  }
  if (page) {
    url += `?page=${page}&`;
  }
  if (page_size) {
    url += `page_size=${page_size}&`;
  }
  if (from_date) {
    url += `?from_date=${from_date}&`;
  }
  if (until_date) {
    url += `?until_date=${until_date}&`;
  }
  if (sort_by) {
    url += `?sort_by=${sort_by}`;
  }
  url = url.endsWith("&") ? url.slice(0, -1) : url;
  return url;
};

export const CHEQUES_RETURNED_BANK = "/supervisor/cheques-returned-to-bank/";

export const GUARANTEE_CHEQUES_RETURNED_BANK =
  "/loan/return-to-bank/guarantee-cheque/";

export const CHEQUE_RETURN_BANK_STATE = "/debts/cheque-return-to-bank-state/";

export const DEBTS_VALUE = (
  creditor_uid: string | null,
  colorFilter?: any,
  cheque_amount?: any,
  cheque_count?: any,
  user_uid?: string | null,
  from_date?: any,
  until_date?: any,
  search_query?: any
) =>
  `/debts/${creditor_uid}/value/?${colorFilter ? `state=${colorFilter}` : ``}${
    cheque_amount ? `&cheques_amount=${cheque_amount}` : ``
  }${cheque_count ? `&cheques=${cheque_count}` : ``}${
    user_uid ? `&expert=${user_uid}` : ``
  }${from_date ? `&from_date=${from_date}` : ``}${
    until_date ? `&until_date=${until_date}` : ``
  }${search_query ? `&search_query=${search_query}` : ``}`;

export const REMOVE_STORE_SAM = (store_uid: string | null) =>
  `/supervisor/remove-store-sam/${store_uid}/`;

export const SUPERVISOR_CANCELS_ORDER = (order_uid: string | null) =>
  `/store/supervisor-cancels-order/${order_uid}/`;

export const STORE_PAID_SETTLEMENT = (id?: string) =>
  `/store/paid-settlement/${id}/`;

export const STORE_AWAIT_SETTLEMENT = (id?: string) =>
  `/store/await-settlement/${id}/`;
export const STORE_PAID_SETTLEMENT_DETAIL = (store_id?: string, id?: string) =>
  `/store/orders-paid/${store_id}/${id}/`;

export const CHANGE_PHONENUMBER = "user/change-phone-nubmer/send-otp/";

export const CHANGE_PHONENUMBER_PHONENUMBER =
  "user/change-phone-nubmer/verify-otp/";

export const STORE_CREATE_COMMENT = "/store/create-comment/";

export const EXEL_PAYMENT_REPORT = (
  from_date?: any,
  until_date?: any
) => `excel/payment-report/?
${until_date ? `date_until=${until_date}&` : ``}
${from_date ? `date_from=${from_date}&` : ``}
`;

export const STORE_GET_COMMENTS = (
  store_uid: string | null,
  page: any,
  page_size: any
) =>
  `/store/${store_uid}/get-comments/?${page ? `page=${page}` : ``}&${
    page_size ? `page_size=${page_size}` : ``
  }`;

export interface ChequeListOptions {
  state?: string | null;
  search_query?: string | null;
  from_date?: string | null;
  until_date?: string | null;
  sort_by?: string | null;
}

export const GET_FILE_UID = (file_uid: string | null) =>
  `/core/file-url/${file_uid}/`;

export const STORE_STORE_GROUP = "/store/store-group/";
export const SUPERVISOR_STOREGROUP = (id: any) =>
  `supervisor/store-group/${id}/`;

export const SUPERVISOR_STORE_GROUP = (uid?: string) =>
  `/supervisor/store-group/${uid ? `${uid}/` : ""}`;

export const DEBTS_REJECT_PAYMENT = (cheque_payment_uid: string | null) =>
  `/debts/reject-payment/${cheque_payment_uid}/`;

export const DEBTS_CHEQUE_PAYMENTS = (creditor_uid: string | null) =>
  `/debts/${creditor_uid}/cheque-payments/`;

export const DEBTS_APPROVE_PAYMENT = (cheque_payment_uid: string | null) =>
  `/debts/approve-payment/${cheque_payment_uid}/`;

export const DEBBTS_PAYMENT_CHEQUE = `/debts/payment/cheque/`;

export const UPDATE_ORDER_ITEM_SERIES_DESC = "/store/order-item-series/";

export const SUPERVISOR_SAM_DEBTS = (creditor_uid: any) =>
  `supervisor/${creditor_uid}/groups-store-debts/?store_group_uid=c01ae549-bce9-4ad1-8538-2bda740eb42b`;

export const SUPERVISOR_EXCEL_STORES_SAM = (creditor_uid: string | null) =>
  `supervisor/${creditor_uid}/groups-store-debt-excel/`;

export const STORE_CONTRACT_DOWNLOAD = (
  store_id: string,
  creditor_id: string
) => `store/creditor-contract/${store_id}/${creditor_id}/`;

export const CONTRACT_STORE = (id: string) => `store/contract/${id}/`;
export const CONTRACT_STORE_SEND = () => `/store/send-contract/`;

// ################# Admin basicinfo ######################

export const ADMIN_APPROVED_CONTRACT = (contract_uid: string) =>
  `/store/supervisor/approve-contract/${contract_uid}/`;

export const ADMIN_REJECT_CONTRACT = (contract_uid: string) =>
  `/store/supervisor/reject-contract/${contract_uid}/`;

export const ADMIN_PRODUCT_GROUP = () => "/admin/product-group/";

export const ADD_ADMIN_PRODUCT_GROUP = () => "/admin/product-group/";

export const REMOVE_UPDATE_ADMIN_PRODUCT_GROUP = (id: string) => {
  return `/admin/product-group/${id}/`;
};

export const ADMIN_GET_UPDATE_PRODUCT_TYPE = (id: string) =>
  `/admin/product-type/${id}/`;

export const ADMIN_ADD_PRODUCT_TYPE = () => `/admin/product-type/`;

export const ADMIN_PRODUCT_ACTIONS = (id: string) => `/admin/product/${id}/`;

export const ADMIN_PRODUCT_ADD = () => "/admin/product/";

export const ADMIN_GET_BRANDS = () => `/admin/brand/`;

export const ADMIN_GET_BANKS = "/admin/bank/";

export const CREDITOR_STORE_BANKS = "/store/creditor-store-bank/";

export const ADMIN_UPDATE_BANKS = (bank_uid: string) =>
  `/admin/bank/${bank_uid}/`;

export const ADMIN_ACTION_BRANDS = (id: string) => `/admin/brand/${id}/`;

export const ADMIN_GET_JOBCATEGORY = () => "/admin/job-category/";

export const ADMIN_CREATE_JOBCATEGORY = () => "/admin/job_category/create/";

export const ADMIN_DELETE_JOBCATEGORY = (id: string) =>
  `/admin/job_category/delete/${id}/`;

export const ADMIN_UPDATE_JOBCATEGORY = (id: string) =>
  `/admin/job_category/update/${id}/`;

export const ADMIN_PROVINCE_CREATE = `/admin/province/create/`;

export const ADMIN_PROVINCE_UPDATE = (id: string) =>
  `/admin/province/update/${id}/`;

export const ADMIN_PROVINCE_DELETE = (id: string) =>
  `/admin/province/delete/${id}/`;

export const ADMIN_PROVINCE_GET = `/core/province/`;

export const ADMIN_GET_CITY = (id: number) => `/core/city/?search=${id}`;

export const ADMIN_UPDATE_CITY = (id: number) => `/admin/city/update/${id}/`;

export const ADMIN_DELETE_CITY = (id: number) => `/admin/city/delete/${id}/`;

export const ADMIN_CREATE_CITY = `/admin/city/create/`;

export const HAS_BLUE_ACCOUNT = (order_uid: string) =>
  `/loan/has-blu-account/${order_uid}/`;

export const EXCEL_GUARANTEE_CHEQUES = (creditor_uid: any) =>
  `/creditor/excel/${creditor_uid}/guarantee-cheques/`;

export const DEBTS_EXCEL_CHEQUE_PAYMENTS = (creditor_uid: any) =>
  `/debts/${creditor_uid}/excel-cheque-payments/`;

export const ORDER_APPROVAL_STATE = () => `loan/order-approval-state/`;

export const CREDITOR_CLOSED_DEBTS = (
  creditor_uid: string | null,
  pageNumber?: number,
  pageSize?: number,
  state?: any,
  search_query?: string,
  from_date?: any,
  until_date?: any,
  expert?: string | null,
  cheque_amount?: any,
  cheque_count?: any,
  sort_by?: any
) =>
  `debts/${creditor_uid}/closed-debts/?page=${pageNumber}&page_size=${pageSize}${
    search_query ? `&search_query=${search_query}` : ``
  }${state ? `&state=${state}` : ``}${
    from_date ? `&from_date=${from_date}` : ``
  }${expert ? `&expert=${expert}` : ``}${
    cheque_amount ? `&cheques_amount=${cheque_amount}` : ``
  }${cheque_count ? `&cheques=${cheque_count}` : ``}${
    until_date ? `&until_date=${until_date}` : ``
  }${sort_by ? `&sort_by=${sort_by}` : ``}`;

export const ROLLBACK_ORDER = (order_uid: string) =>
  `/supervisor/rollback-order/${order_uid}/`;

export const USER_GET_CREDIT = (user_uid: string) =>
  `/supervisor/get-credit/${user_uid}/`;

export const INITIAL_STORE_DETAILS = (initial_store_info_uid: string) =>
  `/store/initial-store-info/${initial_store_info_uid}/`;

export const INITIAL_STORE_INFO_POST = `/store/initial-store-info/`;

export const EXPERTS_GURANTEES = (creditor_uid: any) =>
  `/loan/experts-gurantees/${creditor_uid}/`;

export const SMS_PATTERN_LIST = (creditor_uid: any) =>
  `/portal/sms-patterns-list/${creditor_uid}`;

export const AT_FINANCIAL_DEBT_GUARANTEE = (guarantee_cheque_uid: any) =>
  `/loan/at-financial-debt/guarantee-cheque/${guarantee_cheque_uid}/`;

export const AT_FINANCIAL_DEBT_GUARANTEE_LIST = (creditor_uid: any) =>
  `/debts/${creditor_uid}/gurantees/at-financial-debts/`;

export const NEXT_SEND_OTP = "/debts/extradition/send-otp/";

export const EXCEL_GUARANTORS = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `supervisor/excel/${creditor_uid}/guarantors/?
${until_date ? `until_date=${until_date}&` : ``}
${from_date ? `from_date=${from_date}&` : ``}
`;

export const LIST_STORE_ORDERS_USERS = (
  store_uid: string | null,
  pageNumber: number,
  pageSize: number,
  search_query: string,
  from_date?: string,
  until_date?: string
) => {
  let url = `store/${store_uid}/store-customers-list/?page=${pageNumber}&search_query=${search_query}&page_size=${pageSize}`;

  if (from_date) {
    url += `&from_date=${from_date}`;
  }
  if (until_date) {
    url += `&until_date=${until_date}`;
  }
  url = url.endsWith("&") ? url.slice(0, -1) : url;
  return url;
};

export const STORE_CUSTOMER = "/store/store-customer/";

export const STORE_ORDERS_USERS_DELETE = (store_customer_uid: string | null) =>
  `/store/store-customer/${store_customer_uid}/`;

export const STORE_CUSTOMER_ORDER = "/store/store-customer-order/";

export const RECEIVER_INSTALMENT_EXTRADITION = (
  instalment_cheque__instalment__instalment_uid: string | null
) =>
  `debts/receiver-instalment-extradition/${instalment_cheque__instalment__instalment_uid}/`;

export const RECEIVER_GUARANTEE_EXTRADITION = (
  guarantee_cheque__guarantee_cheque_uid: string | null
) =>
  `/creditor/receiver-guarantee-extradition/${guarantee_cheque__guarantee_cheque_uid}/`;

export const ARCHIVE_GUARANTEE_CHEQUE = (guarantee_cheque_uid: string | null) =>
  `debts/archive-guarantee-cheque/${guarantee_cheque_uid}/`;

export const APPROVE_PAYMENT_ORDER = (debt_order_uid: string | null) =>
  `/debts/approve-payment/debt-order/${debt_order_uid}/`;

export const REJECT_PAYMENT_ORDER = (debt_order_uid: string | null) =>
  `/debts/reject-payment/debt-order/${debt_order_uid}/`;

export const ADMIN_UPDATE_CREDIT = (user_uid: string | null) =>
  `/admin/update-credit/${user_uid}/`;

export const ADMIN_CREDIT_AI = (credit_uid: string | null) =>
  `/supervisor/vam30-credit-token/${credit_uid}/`;

export const ADMIN_CREDIT_AI_TICKET = (credit_uid: string | null) =>
  `/supervisor/vam30-credit/${credit_uid}/`;

export const GUARANTEED_ORDERS = (user_uid: string | null) =>
  `/supervisor/guaranteed-orders/${user_uid}/`;

export const CREDITOR_STORE_BANK_LIST = (uid: string | null) =>
  `/store/creditor-store-bank/${uid}/`;

export const STORE_COMMENTS = (
  store_uid: string | null,
  page?: number,
  page_size?: number
) => `/store/${store_uid}/get-comments/?page=${page}&page_size=${page_size}`;

export const STORE_LOAN_CALCULATOR = (store_uid: string | null) =>
  `/store/loan-calculator/${store_uid}/`;

export const BLUBANK_INSTALMENT_DEBTS = (
  creditor_uid: string | null,
  search_query?: string,
  expert?: string | null
) => `/instalment-debts/${creditor_uid}/debts/
${search_query ? `?&search_query=${search_query}` : ``}${
  expert ? `?&expert=${expert}` : ``
}`;

export const BLU_SETTLEMENT = (debt_file_uid: string | null) =>
  `/instalment-debts/blu-settlement/${debt_file_uid}/`;

export const INSTALMENT_MESSAGE = "/admin/instalment-message/";

export const INSTALMENT_DETAIL_DEBT = (debt_file_uid: string | null) =>
  `/instalment-debts/instalment-detail-debt/${debt_file_uid}/`;

export const BLU_DEBTS_LIST_DETAILS_CHEQUE = (debt_file_uid: string | null) => {
  return `instalment-debts/list-details-instalment/${debt_file_uid}/`;
};

export const BLU_DEBTS_LIST_DETAILS_GUARANTEE_CHEQUE = (
  debt_file_uid: string | null
) => {
  return `debts/details-guarantee/${debt_file_uid}/`;
};

export const BLU_INSTALMENT_CHEQUE_NOTE = (note_uid: string | null) => {
  return `instalment-debts/instalment-note/${note_uid}/ `;
};

export const BLU_INSTALMENT_CHEQUE_NOTE_POST =
  "instalment-debts/instalment-note/";

export const ADD_GUARANTEE_CHEQUE = (order_uid: string | null) => {
  return `/loan/add-guarantee-cheque/${order_uid}/ `;
};

export const REMOVE_GUARANTEE_CHEQUE = (
  guarantee_cheque_uid: string | null
) => {
  return `/loan/remove-guarantee-cheque/${guarantee_cheque_uid}/ `;
};

export const ARCHIVE_INSTALMENT_CHEQUE = (debt_cheque_uid: string | null) =>
  `debts/undo-at-financial-debt/${debt_cheque_uid}/`;

export const SUPERVISOR_UNDO_STATE = (order_uid: string | null) =>
  `/supervisor/undo-state/${order_uid}/`;

export const GUARANTEE_EXTRADITION_FINANCIAL = (
  guarantee_cheque__guarantee_cheque_uid: string | null
) =>
  `/creditor/guarantee-extradition-financial/${guarantee_cheque__guarantee_cheque_uid}/`;

export const INSTALMENT_EXTRADITION_FINANCIAL = (
  instalment_cheque__instalment__instalment_uid: string | null
) =>
  `/debts/instalment-extradition-financial/${instalment_cheque__instalment__instalment_uid}/`;

export const INSTALMENT_DEBTS_LEGAL_FILES = (
  creditor_uid: string | null,
  search_query: string | null,
  debt_state: string | null,
  has_legal_statement: string | null,
  page: number | null,
  page_size: number | null
) =>
  `/instalment-debts/${creditor_uid}/instalment-legal-files/?${
    search_query ? `&search_query=${search_query}` : ``
  }${debt_state ? `&debt_state=${debt_state}` : ``}${
    has_legal_statement ? `&has_legal_statement=${has_legal_statement}` : ``
  }${page ? `&page=${page}` : ``}${page_size ? `&page_size=${page_size}` : ``}`;

export const BLU_EXPERT_LIST = (credit_uid: string | null) =>
  `/instalment-debts/experts/${credit_uid}/`;

export const DEBT_SEND_SMS_BLU = "/instalment-debts/debt-send-sms/";

export const DEBT_SEND_SMS = "/portal/send-sms-to-user/";

export const EXEL_AT_BLU_INSTALMENT_PAYMENT_REPORT = (
  creditor_uid: string | null,
  from_date?: any,
  until_date?: any
) => `excel/instalment-payments/?${
  until_date ? `date_until=${until_date}&` : ``
}
  ${from_date ? `date_from=${from_date}&` : ``}`;

export const ADMIN_DAILY_QUESTION = `/admin/daily-question/?page=1&page_size=100`;

export const ADMIN_DAILY_QUESTION_UPDATE = (id: string) => {
  return `/admin/daily-question/${id}/`;
};

export const DEBTS_VALUE_BLU = (
  creditor_uid: string | null,
  search_query?: any,
  state?: any,
  expert?: string | null
) =>
  `/instalment-debts/${creditor_uid}/debt-value/?${
    search_query ? `&search_query=${search_query}` : ``
  }${expert ? `&expert=${expert}` : ``}${state ? `&state=${state}` : ``}`;

export const SWITCH_PHONENUMBERS = (old_phone_number: string | null) =>
  `/admin/switch-phonenumbers/${old_phone_number}/`;

export const GANJOOR_RANDOM_POEM_JSON = "https://c.ganjoor.net/beyt-json.php";
export const BLU_CLOSED_DEBTS = (creditor_uid: any) =>
  `/debts/${creditor_uid}/blu-closed-debts/`;

export const REPAYMENT_BLU = (instalment_payment_uid: any) =>
  `/instalment-debts/${instalment_payment_uid}/repayment-blu/`;
